<template>
  <div class="sidebar">
    <div class="sidebar-brand">
      <b-link to="/orders/ecommerce">
        <img src="/images/logo-white.png" />
      </b-link>
    </div>
    <nav class="sidebar-nav mt-2">
      <ul class="nav">
        <template>
          <li class="nav-item-borderless logo-sm" v-if="isCollaped">
              <span>
                <img src="/images/logo-symbol.png" class="icon" style="margin: 0; margin-top: 5px"/>
              </span>
          </li>
          <!-- new shipment -->
          <li class="nav-item-borderless">
            <router-link to="/orders/new-shipment" class="nav-link">
              <span>
                <img src="/images/icon-new-shipment.png" class="icon" id="tt-new"/>
                <b-tooltip v-if="isCollaped" target="tt-new" triggers="hover">New Shipment</b-tooltip>
                New Shipment
              </span>
            </router-link>
          </li>
          <!-- ecommerce -->
          <li class="nav-item-borderless position-relative">
            <router-link to="/orders/ecommerce" class="nav-link">
              <span>
                <img src="/images/icon-ready-to-ship.png" class="icon" id="tt-integration"/>
                <b-tooltip v-if="isCollaped" target="tt-integration" triggers="hover">E-commerce Store</b-tooltip>
                E-commerce Store
              </span>
            </router-link>
            <b-badge v-if="ecommerceCount" class="count-badge" pill variant="primary">{{ ecommerceCount }}</b-badge>
          </li>
          <!-- awaiting payment -->
          <!-- <li class="nav-item-borderless">
            <router-link to="/orders/pending" class="nav-link">
              <span>
                <img src="/images/icon-pending-orders.png" class="icon" id="tt-pending"/>
                <b-tooltip v-if="isCollaped" target="tt-pending" triggers="hover"> Awaiting Payment</b-tooltip>
                Awaiting Payment
              </span>
            </router-link>
          </li> -->
          <!-- import orders -->
          <li class="nav-item-borderless position-relative">
            <router-link to="/orders/import" class="nav-link">
              <span>
                <img src="/images/icon-import.png" class="icon" id="tt-import"/>
                <b-tooltip v-if="isCollaped" target="tt-import" triggers="hover">Import Orders</b-tooltip>
                Import Orders
              </span>
            </router-link>
            <b-badge v-if="importCount" class="count-badge" pill variant="primary">{{ importCount }}</b-badge>
          </li>
          <!-- shipped -->
          <li class="nav-item-borderless">
            <router-link to="/orders/shipped" class="nav-link">
              <span>
                <img src="/images/icon-shipped.png" class="icon" id="tt-shipped"/>
                <b-tooltip v-if="isCollaped" target="tt-shipped" triggers="hover">Shipped</b-tooltip>
                Shipped
              </span>
            </router-link>
          </li>
          <!-- address book -->
          <li class="nav-item-borderless">
            <router-link to="/address-book" class="nav-link">
              <span>
                <img src="/images/icon-address-book.png" class="icon" id="tt-addressbook"/>
                <b-tooltip v-if="isCollaped" target="tt-addressbook" triggers="hover">Address Book</b-tooltip>
                Address Book
              </span>
            </router-link>
          </li>
          <!-- Returns -->
          <li class="nav-item-borderless">
            <router-link to="/labels/return" class="nav-link">
              <span>
                <img src="/images/icon-sb-return.png" class="icon" id="tt-sbr"/>
                <b-tooltip v-if="isCollaped" target="tt-sbr" triggers="hover">SB Return Labels</b-tooltip>
                SB Return Labels
              </span>
            </router-link>
          </li>
          <!-- Voided -->
          <li class="nav-item-borderless">
            <router-link to="/labels/voided" class="nav-link">
              <span>
                <img src="/images/icon-voided.png" class="icon" id="tt-void"/>
                <b-tooltip v-if="isCollaped" target="tt-void" triggers="hover">Voided Labels</b-tooltip>
                Voided Labels
              </span>
            </router-link>
          </li>
          <!-- guaranteed delivery-->
          <!-- <li v-if="user.enable_guaranteed_claim && user.subscribed" class="nav-item-borderless">
            <router-link to="/orders/guarantee" class="nav-link">
              <span>
                <img src="/images/icon-guarantee.png" class="icon" id="tt-guarantee"/>
                <b-tooltip v-if="isCollaped" target="tt-guarantee" triggers="hover">Guaranteed Claims</b-tooltip>
                Guaranteed Claims
              </span>
            </router-link>
          </li> -->
                <!-- <img src="/images/icons/beta.png" class="beta"/> -->
          <!-- <li v-else class="nav-item-borderless">
            <b-link :to="showSupreme ? '/enterprise-features?guaranteedClaim=1' : ''" class="nav-link link-disabled" :disabled="!showSupreme">
              <span>
                <img src="/images/icon-guarantee-disabled.png" class="icon" id="tt-guarantee"/>
                <b-tooltip v-if="isCollaped" target="tt-guarantee" triggers="hover">Guaranteed Claims</b-tooltip>
                Guaranteed Claims
              </span>
            </b-link>
          </li> -->
                <!-- <img src="/images/icons/beta-disabled.png" class="beta"/> -->
          <li class="nav-item-burger" v-if="!isSmallScreen">
            <b-button
              v-b-tooltip.hover
              :title="isCollaped? 'Expand' : 'Collapse'"
              class="px-2 py-1 pull-right"
              variant="link"
              @click="sidebarMinimize"
            >
              <!-- collapse -->
              <svg v-if="!isCollaped" width="1.5rem" height="1.5rem" viewBox="0 0 16 16" class="bi bi-arrow-bar-left" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M5.854 4.646a.5.5 0 0 0-.708 0l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L3.207 8l2.647-2.646a.5.5 0 0 0 0-.708z"/>
                <path fill-rule="evenodd" d="M10 8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0 0 1h6.5A.5.5 0 0 0 10 8zm2.5 6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5z"/>
              </svg>
              <!-- expand -->
              <svg v-else width="1.5rem" height="1.5rem" viewBox="0 0 16 16" class="bi bi-arrow-bar-right" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z"/>
                <path fill-rule="evenodd" d="M6 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H6.5A.5.5 0 0 1 6 8zm-2.5 6a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 1 0v11a.5.5 0 0 1-.5.5z"/>
              </svg>
            </b-button>
          </li>

          <li class="flex-grow-1"></li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.count-badge {
  position: absolute;
  right: 7px;
  top: 0;
  z-index: 100;
  font-size: 68%;
}
.beta{
  float: right; z-index:1000;margin-top: -2rem; height: 0.75rem;
}
.nav-link {
  position: relative;
  &:hover{
    color: #ffc93a !important
  }
  span {
    position: relative;
    display: block;
    margin: 0 auto;
    padding-left: 55px;
    font-size: 15px;
  }
}
.icon {
  position: absolute;
  left: 13px;
  top: 0;
  bottom: 0;
  width: auto;
  height: 22px;
  margin: auto;
  margin-right: 0.5rem;
  vertical-align: middle;
}
</style>


<script>
import { mapGetters } from "vuex";

export default {
  name: "sidebar",

  created: function() {
    window.addEventListener("resize", this.checkWindowWidth);
    if (window.innerWidth <= 768) {
      this.isCollaped = true;
      this.isSmallScreen = true;
      document.body.classList.toggle("sidebar-minimized", true);
      return false;
    }
  },
  data(){
    return {
      isCollaped: false,
      isSmallScreen: false,
      // showSupreme: true,
    }
  },
  mounted(){
    // this.showSupreme = (this.employee) ? false : true;
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      employee: "getEmployeeName",
      ecommerceCount: "getEcommerceCount",
      importCount: "getImportCount",
    })
  },
  methods: {
    checkWindowWidth() {
      // console.log('side bar', window.innerWidth);
      if (window.innerWidth <= 768) {
        this.isCollaped = true;
        this.isSmallScreen = true;
        document.body.classList.toggle("sidebar-minimized", true);
        return false;
      } else {
        this.isCollaped = false;
        this.isSmallScreen = false;
        document.body.classList.toggle("sidebar-minimized", false);
        return true;
      }
    },
    sidebarMinimize(e) {
      // e.preventDefault();
      this.isCollaped = !this.isCollaped;
      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Sidebar.vue